import React from 'react' 
import Inbondview from '../../components/inbond/inbondview'  // Table or list of inbond records

export default function Inbond() {
  return (
    <>
    {/* View section (displays inbond entries) */}
    <div className='px-4'>
      <Inbondview/>
    </div>
    </>
  )
}
